import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Router } from 'react-router-dom';
import WebFont from 'webfontloader';

import { i18nInstance } from 'src/i18n';
import { history } from 'src/store/history';

import { ErrorReporter } from '../ErrorReporter/ErrorReporter';
import { ScrollToTop } from '../ScrollToTop/ScrollToTop';

import { PartnerAttributionProvider } from 'src/services/analytics/PartnerAttribution';
import { CachedDCSProvider } from 'src/services/dcs/CachedDCS';
import { App } from '../App/App';
import { BankPersonalizationProvider } from '../BankPersonalization/BankPersonalization';
import { BusyLoader } from '../BusyLoader/BusyLoader';
import { CartProvider } from '../Cart/CartProvider';
import { DynamicModalProvider } from '../DynamicModal/DynamicModal';
import { FeatureFlagsProvider } from '../FeatureFlags/FeatureFlags';
import { Matryoshka } from '../Matryoshka/Matryoshka';
import { NavBarProvider } from '../NavBarContext/NavBarContext';
import { ProductPricingProvider } from '../ProductPricing/ProductPricing';
import { ProgramPromotionProvider } from '../ProgramPromotion/ProgramPromotion';
import { ResponsiveProvider } from '../Responsive/Responsive';
import { SalesChannelProvider } from '../SalesChannel/SalesChannel';
import { ShopTemplateContextProvider } from '../ShopTemplateContext/ShopTemplateContext';
import { SidebarProvider } from '../SidebarContext/SidebarContext';

export class Root extends React.Component {
  componentDidMount() {
    if (document.documentElement && !document.documentElement.classList.contains('wf-active')) {
      WebFont.load({
        loading() {
          Array.from(document.getElementsByClassName('material-icons')).forEach(element => {
            element.classList.add('wf-loading');
          });
        },
        active() {
          Array.from(document.getElementsByClassName('wf-loading')).forEach(element => {
            element.classList.remove('wf-loading');
            element.classList.add('wf-active');
          });
        },
        google: {
          // Load Material Icons options
          // https://github.com/typekit/webfontloader/issues/409
          families: ['Material Icons&display=block'],
        },
      });
    }
  }

  render() {
    return (
      <Matryoshka
        wrappers={[
          // React.StrictMode
          ({ children }) => <ErrorReporter boundary="root">{children}</ErrorReporter>,
          ({ children }) => <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>,
          ({ children }) => <Suspense fallback={<BusyLoader />}>{children}</Suspense>,
          ({ children }) => <Router history={history}>{children}</Router>,
          ({ children }) => <BankPersonalizationProvider>{children}</BankPersonalizationProvider>,
          PartnerAttributionProvider,
          SalesChannelProvider,
          FeatureFlagsProvider,
          ProgramPromotionProvider,
          ProductPricingProvider,
          ShopTemplateContextProvider,
          ScrollToTop,
          ResponsiveProvider,
          SidebarProvider,
          NavBarProvider,
          CartProvider,
          DynamicModalProvider,
          CachedDCSProvider,
          App,
        ]}
      />
    );
  }
}
